<template>
    <div>
        <transition name="popup">
            <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
                <div class="popup-container">

                    <button class="popup-close" @click="closePopup"><svg width="18" height="19" viewBox="0 0 18 19"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.494853 15.703C-0.144973 16.3298 -0.158031 17.4789 0.50791 18.1448C1.17385 18.8108 2.32293 18.7847 2.94969 18.1579L9.00845 12.0991L15.0672 18.1448C15.7201 18.7977 16.8431 18.8108 17.509 18.1318C18.1749 17.4658 18.1749 16.3429 17.5221 15.69L11.4764 9.64428L17.5221 3.58553C18.1749 2.93264 18.1749 1.80968 17.509 1.14374C16.8431 0.464742 15.7201 0.4778 15.0672 1.13068L9.00845 7.17638L2.94969 1.11763C2.32293 0.490858 1.17385 0.464742 0.50791 1.13068C-0.158031 1.79662 -0.144973 2.9457 0.494853 3.58553L6.55361 9.64428L0.494853 15.703Z"
                                fill="#FFFFFF" />
                        </svg></button>
                    <transition name="fade">
                        <div class="popup-content" v-if="!success && !errorSms">
                            <div>
                                <div class="mb-5">
                                    <p class="otp-title">введите код</p>
                                    <p class="otp-description">На номер был отправлен код, для того чтобы продолжить
                                        введите
                                        код</p>
                                </div>
                                <div class="ma-auto position-relative" style="max-width: 300px">
                                    <v-otp-input v-model="otp" length="4" :disabled="loading" type="tel"></v-otp-input>
                                    <v-overlay absolute :value="loading">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-overlay>
                                </div>

                                <div v-if="errorMessage" class="mt-2">
                                    <p class="code-error">код введен неверно</p>
                                </div>

                                <div class="sms-timer mt-4">
                                    <p v-if="smsTimer > 0">Повторно отправить SMS можно через {{ smsTimer }} сек.</p>
                                    <button v-else @click="$emit('resend')" class="resend-btn">Повторно отправить
                                        SMS</button>
                                </div>


                                <div class="btn-container-success">
                                    <button class="btn-success" @click="confirmOtp" :disabled="loading">{{ loading ?
                                        'Отправка...' : 'Подтвердить' }}</button>
                                </div>



                            </div>

                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="popup-content-success" v-if="success">
                            <p class="otp-success-text">
                                <!-- Готово!<br/> -->
                                Спасибо за регистрацию!
                            </p>
                        </div>
                        <div class="popup-content-error" v-if="errorSms">
                            <p class="otp-success-error mb-3">Вы уже зарегистрированы</p>
                            <p class="otp-success-error">Повторная регистрация невозможна</p>
                        </div>
                    </transition>


                </div>
            </div>
        </transition>
    </div>
</template>

<style scoped>
.popup-content-error {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
    /* чтобы занять всю высоту контейнера */
    width: 100%;
    /* чтобы занять всю ширину контейнера */
    text-align: center;
    padding: 0 56px;
}
.otp-success-error {
    font-weight: 700;
    font-size: 40px;
    color: var(--color-white);
    text-transform: uppercase;
    font-family: var(--font-family-bold);
    margin-bottom: 0px;
    line-height: 1.3;
    /* max-width: 338px; */
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.popup-content-success {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    /* чтобы занять всю высоту контейнера */
    width: 100%;
    /* чтобы занять всю ширину контейнера */
    text-align: center;
    padding: 0 56px;
}

.otp-success-text {
    font-weight: 500;
    font-size: 64px;
    color: var(--color-white);
    text-transform: uppercase;
    font-family: var(--font-family);
    margin-bottom: 0px;
    line-height: 1.3;
    max-width: 338px;
}

.btn-container-success {
    margin-top: 85px;
}

.btn-success {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    background: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary);
    cursor: pointer;
    box-shadow: 0 4px 0 #c6c4c4;

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении (быстрее, чем возврат) */
.btn-success:hover {
    background: var(--color-white);
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #c6c4c4;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-success:active {
    background: #0000AA;
    transform: translateY(2px);
    box-shadow: 0 2px 0 #0909aa;
    transition: all 0.1s ease-in;
}

.sms-timer .resend-btn {
    text-decoration: underline;
    font-family: var(--font-family);
    color: var(--color-white);
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
}

.sms-timer {
    font-weight: 500;
    font-size: 20px;
    color: var(--color-white);
    font-family: var(--font-family)
}

.code-error {
    color: #FE5050;
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 0px;
    text-align: center;
}

::v-deep .v-otp-input input {
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    color: black !important;
}
::v-deep .v-text-field--outlined fieldset {
  border: none !important;        /* убираем серую рамку */
  outline: none !important;       /* убираем выделение при фокусе */
  box-shadow: none !important;    /* убираем внутреннюю тень */
  border-radius: 0 !important;    /* убираем закругление сверху */
}

::v-deep .v-text-field--outlined>.v-input__control>.v-input__slot {
    align-items: stretch;
    min-height: 85px;
}

::v-deep .theme--light.v-otp-input .v-input .v-input__control .v-input__slot {
    background: var(--color-white);
}

.popup-content {
    padding-top: 30px;
}

.otp-description {
    font-weight: 700;
    font-size: 24px;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    margin-bottom: 0px;
    max-width: 420px;
    margin: auto;
}

.otp-title {
    font-weight: 500;
    font-size: 40px;
    color: var(--color-white);
    font-family: var(--font-family);
    text-transform: uppercase;
    margin-bottom: 0px;
}

.position-relative {
    position: relative;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-container {
    /* background-image: url('../assets/img/absolut-reg-form-bg.jpg');
    background-size: cover; */
    background-color: var(--color-primary-dark);
    background-position: center;
    padding: 20px;
    text-align: center;
    position: relative;
    border-radius: 30px;
    width: 594px;
    height: 542px;
}

.popup-content,
.popup-content-success {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.popup-close {
    position: absolute;
    top: 25px;
    right: 27px;
    background: none;
    border: none;
    color: #f2e4b5;
    cursor: pointer;
    z-index: 10;
    /* добавьте эту строку */
}

.popup-logo {
    width: auto;
    height: auto;
    margin-bottom: 38px;
    margin-top: 10px;
}

.popup-title {
    font-family: "jj2bold";
    font-weight: 700;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #f2e4b5;
    margin-bottom: 31px;
}

.popup-text {
    font-family: "jj2bold";
    font-weight: 700;
    font-size: 36px;
    text-align: center;
    color: #f2e4b5;
    max-width: 346px;
    width: 100%;
    margin-bottom: 0px;
    line-height: 1.2;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}
@media (min-width: 566px) and (max-width: 1024px) {
    .popup-container {
        height: 440px;
        width: 564px;
    }
    .btn-container-success {
        margin-top: 20px;
    }
}
@media screen and (max-width: 566px){
    .popup-content-error {
        padding: 0px;
    }
    .otp-title {
        font-family: var(--font-family);
        font-weight: 500;
        font-size: 24px;
    }
    .otp-description {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 20px;
    }
    .sms-timer .resend-btn {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 20px;
    }
    .btn-success {
        font-family: var(--font-family);
        font-weight: 500;
        font-size: 20px;
    }
    .otp-success-error {
        font-size: 30px;
    }
    .popup-container {
        height: 468px;
        width: 564px;
        /* margin: 0 15px; */
    }
    .position-relative {
    max-width: 275px !important;
    }
    ::v-deep .v-otp-input input {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: var(--color-black) !important;
    }
}
</style>



<script>

export default {


    name: "otp",
    props: {
        showPopup: {
            type: Boolean,
            default: false,

        },
        smsTimer: {
            type: Number,
            default: 0
        },
        success: {
            type: Boolean,
            default: false,
        },
        errorSms: {
            type: Boolean,
            default: false
        },       
        errorMessage: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: false,
        },   // текст ошибки
    },
    data() {
        return {

            otp: '',
            expectedOtp: '1111',
            isSuccess: false,
            // errorSms: false,
            // timer: 60, // 60 секунд
            // timerInterval: null,
        };
    },
    methods: {

        confirmOtp() {
            this.$emit('verifyCode', this.otp);
        },

        closePopup() {
            this.$emit('closePopup');
            this.otp = '';
            this.success = false;
            this.errorMessage = '';
            this.errorSms = false;
            this.loading = false;
        },

    },
    watch: {
        otp(newVal) {
            console.log('OTP:', newVal);
        }
    },


    mounted() {
    }
}

</script>